import React from 'react';
import { Dialog } from '../../../../Components/MUIs';
import './LEG_BASIC_LawSelectDialog.styles.css';

/** 법규준수평가 — 법령(양식) 삭제 확인 팝업 */
function LEG_BASIC_DeleteLawDialog({
  open = false,
  lawNm = '',
  onClose = () => {},
  onConfirm = () => {},
}) {
  const name = String(lawNm ?? '').trim();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="법령 삭제"
      maxWidth="sm"
      fullWidth
      useSaveButton={true}
      useCloseButton={true}
      saveButtonName="삭제"
      closeButtonName="취소"
      onSave={onConfirm}
      titleSx={{ pb: 1, fontWeight: 700, fontSize: 18 }}
      contentSx={{ pt: 4, px: 2.5, pb: 2.5 }}
      content={
        <div className="leg-law-select">
          <div className="leg-law-select__intro leg-law-select__intro--danger">
            <div className="leg-law-select__intro-icon leg-law-select__intro-icon--danger">
              <span className="material-symbols-outlined">delete</span>
            </div>
            <div>
              <div className="leg-law-select__intro-title">
                점검표 선택 목록에서 법령을 삭제할까요?
              </div>
              <p className="leg-law-select__intro-desc">
                목록에서만 제거되며, 이미 작성·저장된 기본정보 점검표는
                삭제되지 않고 그대로 유지됩니다.
              </p>
            </div>
          </div>

          {name ? (
            <div className="leg-law-select__card leg-law-select__card--danger leg-law-select__card--static">
              <div className="leg-law-select__card-main">
                <div className="leg-law-select__card-icon">
                  <span className="material-symbols-outlined">menu_book</span>
                </div>
                <div className="leg-law-select__card-body">
                  <div className="leg-law-select__card-top">
                    <span className="leg-law-select__card-title">{name}</span>
                    <span className="leg-law-select__badge leg-law-select__badge--danger">
                      삭제 대상
                    </span>
                  </div>
                  <p className="leg-law-select__card-desc">
                    이 법령은 점검표 선택 목록에서만 사라집니다. 기본정보
                    목록에 저장된 평가 데이터는 계속 조회·수정할 수 있습니다.
                  </p>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      }
    />
  );
}

export default LEG_BASIC_DeleteLawDialog;
